import React from 'react'
import PropTypes from 'prop-types'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import Img from './Img'
import styles from './TopAppBar.icss'

class TopAppBar extends React.Component {
	render() {
		return (
			<div>
				<div className={styles.offset} />
				<AppBar
					position="fixed"
					classes={{ root: styles.appBar }}
				>
					<Toolbar classes={{ root: styles.toolBar }}>
						{this.props.backButtonFunction && (
							<IconButton
								className={styles.backButton}
								aria-label="Back"
								onClick={this.props.backButtonFunction}
							>
								<ArrowBackIosIcon
									className={styles.backButtonIcon}
								/>
							</IconButton>
						)}

						<Typography
							variant="h1"
							color="inherit"
							classes={{ root: styles.title }}
						>
							{this.props.heading.text && (
								<div className={styles.headingText}>
									{this.props.heading.icon &&
										<Img content={this.props.heading.icon} className={styles.typeIcon} />
									}
									{this.props.heading.text}
								</div>
							)}
							{!this.props.heading.text && (
								<span className={this.props.backButtonFunction ? styles.logoSurroundWithBackButton : styles.logoSurround}>
									<Img className={styles.logo} content="/images/logo/kitfit-logo-white.svg" />
								</span>
							)}
						</Typography>

						<IconButton
							className="moreButton"
							aria-label="More"
							onClick={this.props.handleToggle}
						>
							<MoreVertIcon />
						</IconButton>

					</Toolbar>
				</AppBar>
			</div>
		)
	}
}

TopAppBar.propTypes = {
	backButtonFunction: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.bool
	]).isRequired,
	heading: PropTypes.shape({
		text: PropTypes.string,
		icon: PropTypes.string
	}).isRequired,
	handleToggle: PropTypes.func.isRequired
}


export default TopAppBar



// WEBPACK FOOTER //
// ./src/components/TopAppBar.jsx